import React from 'react'
import Sidebar from '../../components/Sidebar'
import WebhookTable from './components/WebhookTable';

const Webhooks = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      {/* Sidebar handles its own desktop/mobile rendering */}
      <Sidebar />

      {/* Main content — scrolls independently */}
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Providers Webhook Events</h1>

        <div className="">
          <WebhookTable />
        </div>
      </div>
    </div>
  )
};

export default Webhooks